// Module
var code = "<load-spinner class=\"fullscreen\" spinner-name=\"mainSpinner\"></load-spinner>\n<div class=\"app-content\" ui-view=\"app-content\"></div>\n";
// Exports
module.exports = code;